import { ErrorOutlineOutlined } from '@material-ui/icons'
import { useQuery } from '@tanstack/react-query'
import { CanceledError } from 'axios'
import { toast } from 'react-toastify'

import { getHerbicideTreatments } from '@/services/get-herbicide-treatments'

import { useCompanies } from '../use-companies'

export const GET_HERBICIDE_TREATMENTS_QUERY = ['herbicide-treatments']

export function useGetHerbicideTreatments() {
  const { selectedCompany } = useCompanies()

  const query = useQuery({
    queryKey: [...GET_HERBICIDE_TREATMENTS_QUERY, selectedCompany?.id],
    queryFn: async (options) => {
      return getHerbicideTreatments(options).catch((error: Error) => {
        const isNotCancel = !(error instanceof CanceledError)

        isNotCancel &&
          toast.error(
            `Não foi possível carregar as informações, tente novamente. [${error?.message}]`,
            {
              icon: <ErrorOutlineOutlined />,
            },
          )

        throw error
      })
    },
    // onError, TODO: on react query v5 is deprecated
  })

  return query
}
